import { PATH_CONTACT } from './components/path';
import { setSubmissionNum } from './components/AppMain/Test/constants';

window.customHandler = {
    locationChangeHandler: function (location) {
        if (location.hash !== PATH_CONTACT) {
            setSubmissionNum(null);
        }
    },
};

export const getHandler = handlerName => {
    return window.customHandler[handlerName];
};
